import { FC } from 'react'
import { Box, TextField } from '@mui/material'
import BackNavigationHeader, { BackNavigationContent } from 'components/BackNavigationHeader'
import { useLeaseContractsProtocol } from 'services/contracts/hooks/useLeaseContractsProtocols'
import { useLeaseContractsList } from 'services/contracts/hooks/useLeaseContracts'
import MobileBottomFooter from 'components/MobileBottomFooter'
import OperationsFrozenMessage from 'components/OperationsFrozenMessage'
import { useParams, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { LoadingButton } from '@mui/lab'
import { useSnackbar } from 'notistack'
import { useIntl } from 'react-intl'

const AdditionalServicesProtocolAccept: FC = () => {
  const { formatMessage } = useIntl()
  const { id, protocolId } = useParams()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { getActiveContract } = useLeaseContractsList()
  const isOperationsFrozen = getActiveContract(Number(id))?.isOperationsFrozen

  const { leaseContractsProtocolAcceptWithComment } = useLeaseContractsProtocol(
    Number(id),
    Number(protocolId)
  )

  const form = useFormik<{
    comment: string
  }>({
    initialValues: {
      comment: ''
    },
    onSubmit: async ({ comment }, { setSubmitting }) => {
      setSubmitting(true)
      try {
        await leaseContractsProtocolAcceptWithComment(comment)
        enqueueSnackbar(
          formatMessage({
            id: 'additionalServicesProtocolAccept.form.success',
            defaultMessage: 'Protokuł został złożny poprawie.'
          }),
          {
            variant: 'success'
          }
        )
      } catch (e) {
        enqueueSnackbar(
          formatMessage({
            id: 'additionalServicesProtocolAccept.form.error',
            defaultMessage: 'Nie można złożyć protokołu.'
          }),
          {
            variant: 'error'
          }
        )
      }

      setSubmitting(false)
      navigate(`/additional-services/${id}/protocol`)
    }
  })

  return (
    <>
      <BackNavigationHeader
        label={formatMessage({
          id: 'additionalServicesProtocolSpaces.comments',
          defaultMessage: 'Zgłos uwagi'
        })}
      />
      <BackNavigationContent>
        {isOperationsFrozen ? (
          <OperationsFrozenMessage />
        ) : (
          <>
            <Box px={2} mt={1}>
              <TextField
                name='comment'
                onChange={form.handleChange}
                value={form.values.comment}
                label={formatMessage({
                  id: 'additionalServicesProtocolSpaces.form.comment',
                  defaultMessage: 'Opis'
                })}
                sx={{ mb: 4 }}
                fullWidth
                rows={2}
                multiline
                disabled={form.isSubmitting}
              />
            </Box>
            <MobileBottomFooter>
              <LoadingButton
                loading={form.isSubmitting}
                fullWidth
                sx={{ mt: 2 }}
                variant='contained'
                onClick={form.submitForm}
              >
                {formatMessage({
                  id: 'additionalServicesProtocolSpaces.form.submit',
                  defaultMessage: 'Zgłoś'
                })}
              </LoadingButton>
            </MobileBottomFooter>
          </>
        )}
      </BackNavigationContent>
    </>
  )
}

export default AdditionalServicesProtocolAccept
